export * from './src/restaurants-order-pacing-v1-policy-order-pacing-policy.schemas.js';
